export default "__VITE_ASSET__BanDB0$B__"